export default {
  title: 'Validation',
  validated: 'Votre compte a bien été validé',
  connection: 'Vous pouvez dès à présent vous connecter',
  submit: 'Se connecter'
}
